export default __webpack_public_path__ + "1fdab47bf0baff13379937e8369d5269.png";